import { render } from "./Stat.vue?vue&type=template&id=65a57e96"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"
script.render = render

export default script